import { Dialog, Box, Text, Stack, Button } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { CautionIcon } from '@/components/icons'

type Props = {
  visible: boolean
  title: string
  subTitle: string
  onClose: () => void
  onConfirm: () => void
  confirmText?: string
  onSecondary?: () => void
  secondaryText?: string
}

const ConfirmModal = ({
  title,
  subTitle,
  visible,
  onClose,
  onConfirm,
  confirmText = '',
  onSecondary,
  secondaryText = ''
}: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      id="confirmation-dialog"
      width="xsmall"
      open={visible}
      onClose={onClose}
      title={title}
      description={
        <Text size="standard" align="center">
          {subTitle}
        </Text>
      }
      illustration={<CautionIcon />}
    >
      <Stack space="large">
        <Box display="flex" alignItems="center" gap="xsmall" width="full">
          <Button variant="transparent" onClick={onSecondary ?? onClose}>
            {secondaryText || t('common.cancel', 'Cancel')}
          </Button>
          <Button variant="solid" onClick={onConfirm}>
            {confirmText || t('common.confirm', 'Confirm')}
          </Button>
        </Box>
      </Stack>
    </Dialog>
  )
}

export default ConfirmModal
